import { API, FLIB, Dialog } from '../../apis/index.js';
import {
  ERRORS,
  ButtonStatus as BS,
  ButtonDesc as BD,
  SourceType as ST,
  Config
} from '../../apis/enums.js';
import HalfScreenRegion from '../assets/libs/region.js';
import halfScreenDialog from '../assets/libs/base.js';

const Env = WXGAME.Env;

export default {
  name: 'single-gift-btn',
  props: {
    config: Object
  },
  watch: {
    config: {
      handler: function (nv = {}) {
        // console.log(39, Object.keys(nv), nv);
        if (nv && Object.keys(nv).length > 0) {
          if ('status' in nv && 'btn_status' in nv) {
            nv.btn_status = nv.status;
            delete nv.status;
          }
          this.initButton(nv);
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      BS,
      BD,
      appid: '',
      clickable: false,
      is_reward: false,
      need_partition: false,
      partition: 'check_again',
      appitem: {},
      originConf: {},
      status_cls: '',
      source_type: '',
      button_action: '',
      button_params: '',
      button_type: 'default',
      width: '150px',
      height: '40px',
      font: '16px',
      status: 0,
      btn_status: BS.STATUS_NOT_OPEN,
      button_get_text: BD[BS.STATUS_NOT_OPEN],
      button_got_text: BD[BS.STATUS_RECEIVED],
      button_expires_text: BD[BS.STATUS_EXPIRESED],
      button_main: {}
    };
  },
  methods: {
    initButton(conf = {}) {
      if (conf.appitem) {
        this.appitem = FLIB.prepareAppInfo(conf.appitem || {});
      }
      if (conf.appid) {
        this.appid = conf.appid;
      } else if (conf.button_action) {
        this.appid = 'wx62d9035fd4fd2059';
      } else {
        throw new Error('appid must be supplied, but passed ' + JSON.stringify(conf));
        return;
      }
      [
        'button_type',
        'width',
        'height',
        'font',
        'is_reward',
        'need_partition',
        'partition',
        'button_main'
      ].forEach((k) => {
        if (k in conf) {
          this[k] = conf[k];
        }
      });
      if ('type' in conf) {
        this.source_type = conf.type;
      }
      this.btn_status = conf.btn_status || BS.STATUS_NOT_RECEIVED;
      this.renderDesc(conf);
      this.renderClass(conf);
      this.prepareCommonInfo(conf);
      this.parepareInfo(conf);
      // console.log(77, this);
    },
    parepareInfo(conf) {
      switch (parseInt(conf.type)) {
        case ST.TYPE_GIFT:
          this.prepareGiftInfo(conf);
          break;
        case ST.TYPE_CASH:
          this.prepareCashInfo(conf);
          break;
        case ST.TYPE_CUSTOM:
        default:
          this.prepareCustomInfo(conf);
          break;
      }
    },
    prepareCashInfo(conf = {}) {},
    prepareGiftInfo(conf = {}) {},
    prepareCustomInfo(conf = {}) {},
    prepareCommonInfo(conf = {}) {
      let passback = {
        appid: this.appid,
        actid: this.config.actid || conf.actid || 0,
        token: this.config.token || conf.token,
        type: this.config.type || conf.type,
        openid: this.config.openid || conf.openid || '',
        area: conf.area || 0,
        pos: conf.pos || 0,
        event: conf.event || 0,
        giftid: conf.giftid || 0,
        is_owner: conf.is_owner || false,
        game_appid: this.appid
      };
      let enough = false;
      if (conf.token && conf.actid) {
        if (this.need_partition) {
          this.queryPartition();
          Object.assign(passback, {
            token: conf.token,
            actid: conf.actid
          });
        }
        // 兼容只传入领取礼包的参数
        if (!('button_action' in conf) && conf.status == BS.STATUS_NOT_RECEIVED) {
          this.button_action = 'getGift';
        }
        enough = true;
      }
      if (conf.extra) {
        passback.extra = conf.extra;
      }
      if (conf.button_action) {
        Object.assign(passback, {
          button_params: conf.button_params || '',
          button_action: conf.button_action
        });
        this.button_action = conf.button_action;
        this.button_params = conf.button_params;
        enough = true;
      }
      this.originConf = passback;
      if (!enough) {
        throw new Error('missing params: appid & token & actid or button_action');
      }
    },
    renderDesc(conf = {}) {
      if (conf.desc) {
        let desc = conf.desc || {};
        if (desc[BS.STATUS_NOT_OPEN]) {
          this.button_get_text = desc[BS.STATUS_NOT_OPEN];
        }
        if (desc[BS.STATUS_NOT_RECEIVED]) {
          this.button_get_text = desc[BS.STATUS_NOT_RECEIVED];
        }
        if (desc[BS.STATUS_RECEIVED]) {
          this[`button_g${this.is_reward ? 'e' : 'o'}t_text`] = desc[BS.STATUS_RECEIVED];
        }
        if (desc[BS.STATUS_EXPIRESED]) {
          this.button_expires_text = desc[BS.STATUS_EXPIRESED];
        }
        if (desc[BS.STATUS_UNKNOWN]) {
          let key = conf.button_action ? 'button_get_text' : 'button_expires_text';
          this[key] = desc[BS.STATUS_UNKNOWN];
        }
      }
    },
    /**
     *
     * @param conf
     */
    renderClass(conf = {}) {
      let cls = conf.class || {};
      let clickable = conf.status != BS.STATUS_EXPIRESED || conf.button_action;
      this.clickable = clickable;
      this.status_cls = clickable ? cls.enable || 'type_strong' : cls.disable || 'type_disable';
      console.log(
        209,
        clickable,
        this.button_get_text,
        this.btn_status == BS.STATUS_RECEIVED ? this.button_got_text : this.button_expires_text
      );
    },
    /**
     *
     * @param msg
     * @param code
     * @param title
     * @param cbk
     * @param closecbk
     */
    showTips(msg, code = 99, title = '', cbk = false, closecbk = false) {
      let opt = {
        title,
        confirmTxt: code == 0 ? '进入游戏' : '我知道了',
        style: code == 0 ? 'twoBtn' : 'oneBtn',
        code
      };
      if (cbk && typeof cbk == 'function') {
        opt.confirmCb = cbk;
      }
      if (closecbk && typeof closecbk == 'function') {
        opt.closeCb = closecbk;
      }
      Dialog.alert(msg, opt);
    },
    alert(msg, oktext = '我知道了') {
      Dialog.alert(msg, {
        title: '温馨提示',
        style: 'oneBtn',
        confirmTxt: oktext
      });
    },
    /**
     *
     * @param appid
     * @param cbk
     */
    queryPartition(cbk) {
      if (/^wx[a-z0-9]{16}$/i.test(this.appid)) {
        API.hasPartition(
          this.appid,
          (suc, ret) => {
            this.partition = ret;
            if (typeof cbk == 'function') {
              cbk(ret);
            }
          },
          this.is_reward
        );
      }
    },
    /**
     * 分区选择
     * @return void
     */
    showRegion() {
      let _this = this;
      let params = {
        appid: this.appid,
        dialog: halfScreenDialog,
        receiveCallback: (info) => {
          _this.send2Game();
        },
        failCallback: () => {},
        cancelCallback: () => {}
      };
      _this.$emit('event', {
        type: 'region_select',
        data: this.originConf
      });
      new HalfScreenRegion(params);
    },
    /**
     * 领取礼包统一收拢入口
     */
    getGift() {
      let _this = this;
      if (Env.isPC) {
        _this.need_partition = false;
      }
      if (!_this.need_partition) {
        this.send2Game();
        return;
      }
      if (_this.partition == 'check_again') {
        _this.queryPartition((ret) => {
          if (ret != 'check_again') {
            if (ret) {
              _this.showRegion();
            } else {
              _this.send2Game();
            }
          }
        });
      } else if (_this.partition) {
        _this.showRegion();
      } else {
        _this.send2Game();
      }
    },
    /**
     * 领取到兑奖中心逻辑
     *  @return void
     */
    receiveReward() {
      let params = this.originConf || {};
      // console.log(params, 276);
      API.openReward(params.token, (suc, res) => {
        // console.log(271, suc, res);
      });
    },
    updateBtnStatus() {
      this.clickable = true;
      this.button_action = 'jump_url';
      this.button_get_text = '查看';
      this.theme = this.config.jump_theme || this.theme;
    },
    /**
     * 真正领取礼包发送礼包
     * @return void
     */
    send2Game() {
      let _this = this;
      let params = this.originConf || {};
      API[_this.is_reward ? 'sendRewardRequest' : 'sendGiftRequest'](
        _this.appid,
        +params.actid,
        params.token,
        (suc, res) => {
          if (Env.isPC) {
            suc = true;
            res = {
              errcode: suc ? 0 : -1,
              data: {}
            };
          }
          if (suc) {
            if (res && res.errcode == 0) {
              let msg = '领取成功';
              let data = res.data || {};
              _this.btn_status = BS.STATUS_RECEIVED;
              if (_this.source_type == ST.TYPE_CASH || _this.source_type == ST.TYPE_THING) {
                _this.updateBtnStatus();
                _this.$emit('event', {
                  type: 'report',
                  data: Object.assign({}, _this.originConf, { opstat: 109 })
                });
                _this.alert(msg);
                return;
              }
              if (_this.appid) {
                msg = '领取成功, 是否进入游戏？';
              }
              _this.showResultMsg(msg);
              if (_this.is_reward) {
                _this.$emit('event', {
                  type: 'report',
                  data: Object.assign({}, _this.originConf, { opstat: 109 })
                });
                _this.clickable = true;
                _this.button_get_text = '查看';
                if (_this.config.jump_theme) {
                  _this.theme = this.config.jump_theme;
                }
                _this.button_action = 'jump_url';
              } else {
                _this.clickable = false;
                _this.btn_status = BS.STATUS_RECEIVED;
                _this.$emit('event', {
                  type: 'get_gift',
                  data: {
                    ..._this.originConf,
                    errcode: res.errcode
                  }
                });
              }
            } else {
              let msg = '领取失败，请稍后再试';
              if (res && res.errcode in ERRORS) {
                msg = ERRORS[ERRORS[res.errcode]];
              }
              _this.showTips(msg, res.errcode, '温馨提示');
              _this.$emit('event', {
                type: 'get_gift',
                data: {
                  ..._this.originConf,
                  errcode: res.errcode
                },
                errcode: res.errcode,
                errmsg: JSON.stringify(res)
              });
            }
          } else {
            _this.showTips('领取失败，请稍后再试', 110);
            _this.$emit('event', {
              type: 'get_gift',
              data: {
                ..._this.originConf,
                errcode: 110
              },
              errcode: 110,
              errmsg: 'network error'
            });
          }
        }
      );
    },
    showResultMsg(msg) {
      let _this = this;
      _this.showTips(
        msg,
        0,
        '',
        function () {
          if (_this.appid) {
            FLIB.launchApp(_this.appitem, (appitem, ret) => {
              if (ret == -999) {
                return;
              }
              _this.$emit('event', {
                type: 'report',
                data: Object.assign(_this.originConf, { action: ret, appid: this.appid })
              });
            });
          }
        },
        function () {
          _this.$emit('event', {
            type: 'close_launch_game',
            data: Object.assign({}, _this.originConf, { optype: 2 })
          });
        }
      );
    },
    /**
     * 事件触发
     */
    buttonClick() {
      if (!this.clickable) {
        return;
      }
      if (this.button_action == 'jump_url' && this.button_params) {
        FLIB.openUrl(this.button_params, this.appid, Config.closeTimeout);
        this.$emit('event', { type: 'report', data: this.originConf });
      } else if (this.button_action == 'jump_miniapp') {
        FLIB.openMiniApp(this);
        this.$emit('event', { type: 'report', data: this.originConf });
      } else if (this[this.button_action] && typeof this[this.button_action] == 'function') {
        this[this.button_action]();
      } else {
        let conf = this.originConf || {};
        let type = conf.type || conf.button_action || 'custom';
        this.$emit('event', { type, data: this.originConf });
      }
    }
  }
};
